
/*
 * TAG STORE - MODEL
 *
 * This is essentially the Tag MODEL that is used to retrieve information from the Tags Store
 * You can also use it to set information in the tags store, and it will do so using setState, which
 * may cause updates
 *
 * Most everything in here is a passthrough to either SELECTORS (retrieving information from the store)
 * or "REDUCERS" which is used by reducer.js, and is how information is often placed into the store
 *
 */


import store from '../../store';
import { REDUCER_KEY } from './reducer';

import * as selectors from './selectors';
import * as actions from './actions';

/*
 * how we get store state.  "selectors" seem to work off the global store and reducer key.  It then
 * subsequently retrieves
 */
export function getSelectorStore() {
  return store.getState();
}
export function getTagState() {
  return store.getState()[REDUCER_KEY];
}


// Shortcuts to Selectors -----------------------------------------------------------

// These operate on the general REDUCER store, BASE functions
export function getTagsList() {
  return selectors.getTags(getSelectorStore());
}


export function getTagById(id, state) {
  if (state) {
    return selectors.getTagById(state[REDUCER_KEY], id);
  }
  return selectors.getTagById(getTagState(), id);
}
export function getTagByName(name, state) {
  if (state) {
    return selectors.getTagByName(state[REDUCER_KEY], name);
  }
  return selectors.getTagByName(state || getTagState(), name);
}


// Access to Reducers (change state) via ACTIONS (TODO) -------------------------------------------------------------

export function getTags() {
  return store.dispatch(actions.getTags());
}
export function createTag(data) {
  return store.dispatch(actions.createTag(data));
}
